import script from "./KotlinxView.vue?vue&type=script&setup=true&lang=js"
export * from "./KotlinxView.vue?vue&type=script&setup=true&lang=js"

import "./KotlinxView.vue?vue&type=style&index=0&id=089e9257&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-089e9257"]])

export default __exports__